import { SESSION_TOKEN } from 'constants/storage64';
import { decodeStorage } from 'functions/storageBase64';

export const isLogged = () => {
  const isUserLogged = decodeStorage(SESSION_TOKEN);
  return Boolean(isUserLogged);
};
/*
export const isLoggedGuest = () => {
  const isUserLoggedGuest = localStorage.getItem("guest_email");
  return Boolean(isUserLoggedGuest);
};
*/